import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import {csLegacyUrl} from "../../constants";
import {AppNavigationService} from "../../service/app-navigation.service";

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css']
})
export class AppHeaderComponent implements OnInit {

  public csLegacyUrl = '';

  constructor(
    public authService: AuthService,
    public appNavigationService: AppNavigationService
  ) { }

  ngOnInit() {

    this.csLegacyUrl = csLegacyUrl;

  }

  onLogout(){

    this.authService.logout();
    this.appNavigationService.goToSignedOut();

  }

}
